import React from 'react'
import { SkBtnCircle } from '@core/components/btns'
import { SkBtnCircleProps } from '@core/components/btns/skBtnCircle'
import { SkIconUilArrowsVAlt } from '@core/global/icons'
import classNames from 'classnames'

export function SkBtnCircleMove(props: SkBtnCircleProps) {
  return <SkBtnCircle icon={<SkIconUilArrowsVAlt />} {...props} className={classNames('cursor-move', props.className)} />
}
